import React from "react";
import { Route, Switch } from "react-router-dom";
import ApiClientsList from "./ApiClientsList";
import ApiClientForm from "./ApiClientForm";
var ApiClients = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(match.path, "/create"), component: ApiClientForm }),
        React.createElement(Route, { path: ["".concat(match.path, "/:id"), match.path], render: function (routeProps) { return (React.createElement(ApiClientsList, { match: match, selectedId: routeProps.match.params.id })); } })));
};
export default ApiClients;
